import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createReducer } from '@reduxjs/toolkit';
import { ValidationManager, StatusTypes } from '@chegg/commerce-utils';
import { CardTypes } from '../../constants/PaymentTypes';
import { createMOPError, createMOPSuccess, initMOP, loadMOP, resetPaymentForm, resetRecurlyPaymentForm, updateBillingAddress, updateDeviceData, updateFormFieldData, updateMOP, updateMOPError, updatePaymentState } from './PaymentState.actions';
var CCFIELDS = ValidationManager.types.CCFIELDS;
export var initialState = {
  message: {
    text: '',
    type: StatusTypes.EMPTY,
    code: ''
  },
  formFields: _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CCFIELDS.CARDHOLDER_NAME, {
    value: '',
    error: '',
    focused: false,
    empty: true
  }), CCFIELDS.CARD_NUMBER, {
    value: '',
    error: '',
    empty: true
  }), CCFIELDS.EXPIRATION_DATE, {
    value: '',
    error: '',
    focused: false,
    empty: true
  }), CCFIELDS.EXPIRATION_YEAR, {
    value: '',
    error: '',
    focused: false,
    empty: true
  }), CCFIELDS.EXPIRATION_MONTH, {
    value: '',
    error: '',
    focused: false,
    empty: true
  }), CCFIELDS.CVV, {
    value: '',
    error: '',
    focused: false,
    empty: true
  }), "userAddress", {
    error: ''
  }),
  rawData: {
    mopV2: null,
    errors: null,
    errors2: null
  },
  billingAddress: {
    city: '',
    state: '',
    zip: '',
    country: '',
    isZipMandatory: true
  },
  isLoading: true,
  thirdPartyBraintreePayload: {
    details: {
      firstName: '',
      lastName: '',
      billingAddress: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        postalCode: '',
        countryCode: ''
      }
    },
    nonce: '',
    billing: {
      zip: '',
      country: ''
    },
    deviceData: ''
  },
  matchedCards: _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CardTypes.VISA, true), CardTypes.MASTERCARD, true), CardTypes.AMERICANEXPRESS, true), CardTypes.DISCOVER, true),
  deviceData: '',
  rendersRecurlyForm: true,
  cartPriceSummary: {
    total: ''
  }
};
var reducer = createReducer(initialState, function (builder) {
  var message = initialState.message,
    formFields = initialState.formFields,
    matchedCards = initialState.matchedCards,
    billingAddress = initialState.billingAddress;
  builder.addCase(initMOP, function (state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      message: message,
      formFields: formFields
    });
  }).addCase(createMOPSuccess, function (state, action) {
    return _objectSpread(_objectSpread(_objectSpread({}, state), action.payload), {}, {
      isLoading: false,
      message: message,
      formFields: formFields,
      matchedCards: matchedCards
    });
  }).addCase(createMOPError, function (state, action) {
    return _objectSpread(_objectSpread(_objectSpread({}, state), action.payload), {}, {
      isLoading: false
    });
  }).addCase(updateFormFieldData, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      formFields: _objectSpread(_objectSpread({}, state.formFields), action.payload),
      message: message
    });
  }).addCase(loadMOP, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      formFields: _objectSpread(_objectSpread({}, state.formFields), action.payload.formFields)
    });
  }).addCase(updateMOP, function (state, action) {
    return _objectSpread(_objectSpread(_objectSpread({}, state), action.payload), {}, {
      isLoading: true
    });
  }).addCase(updateMOPError, function (state, action) {
    return _objectSpread(_objectSpread(_objectSpread({}, state), action.payload), {}, {
      isLoading: false
    });
  }).addCase(updatePaymentState, function (state, action) {
    return _objectSpread(_objectSpread({}, state), action.payload);
  }).addCase(resetPaymentForm, function (state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      matchedCards: matchedCards,
      billingAddress: billingAddress,
      formFields: _objectSpread({}, initialState.formFields)
    });
  }).addCase(resetRecurlyPaymentForm, function (state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      rendersRecurlyForm: false
    });
  }).addCase(updateBillingAddress, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      billingAddress: action.payload
    });
  }).addCase(updateDeviceData, function (state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      deviceData: action.payload
    });
  });
});
export default reducer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/PaymentState/PaymentState.reducer.js
// module id = 4532
// module chunks = 11